import { render, staticRenderFns } from "./Custleaving.vue?vue&type=template&id=454118c2&scoped=true"
import script from "./Custleaving.vue?vue&type=script&lang=js"
export * from "./Custleaving.vue?vue&type=script&lang=js"
import style0 from "./Custleaving.vue?vue&type=style&index=0&id=454118c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454118c2",
  null
  
)

export default component.exports